import { Nav } from "rsuite";

const NavbarPreference = ({ active, onSelect, categories, ...props }) => {
  return (
    <div className="nav-client">
      <Nav {...props} activeKey={active} onSelect={onSelect} style={{ marginBottom: 50 }}>
        {categories.map((category) => (
          <Nav.Item id={category.slug} eventKey={category._id}>
            {category.name}
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};
export default NavbarPreference;
